// ==============================|| CONFIG  ||============================== //

import menuItems from './menu-items';
import { NavGroupType } from './menu-items/types';
import { SupportedLocaleType } from './contexts/TranslationContext';

import enIcon from './assets/images/icons/en-flag.svg';
import deIcon from './assets/images/icons/de-flag.svg';

type ConfigType = {
    apiHost: string;
    defaultPath: string;
    fontFamily: string;
    i18n: string;
    defaultSupportedLocales: Array<SupportedLocaleType>;
    dateFormat: string;
    miniDrawer: boolean;
    container: boolean;
    mode: 'light' | 'dark';
    presetColor: string;
    themeDirection: 'ltr' | 'rtl';
    clientId: string;
    acceptableMenuExtensions: Array<{
        name: string;
        items: NavGroupType;
    }>;
    thirdPartyApiKeys?: { [key: string]: string };
    cmsConnectLoad?: string;
};

const config: ConfigType = {
    apiHost: process.env.API_HOST ?? 'https://localhost',
    clientId: process.env.API_CLIENT_ID ?? '',
    // clientId: 'e304160bc07955f90d1257d14393a622', // win-snans

    defaultPath: '/',
    fontFamily: `'Public Sans', sans-serif`,
    i18n: 'en-DE',
    defaultSupportedLocales: [
        {
            locale: 'en-DE',
            title: 'static.settings.lang.en-DE',
            icon: enIcon,
        },
        {
            locale: 'de-DE',
            title: 'static.settings.lang.de-DE',
            icon: deIcon,
        },
    ],
    dateFormat: 'Y-m-d H:i:s',
    miniDrawer: false,
    container: true,
    mode: 'light',
    presetColor: 'default',
    themeDirection: 'ltr',
    acceptableMenuExtensions: [
        {
            name: 'qlive_core_cms',
            items: menuItems.cms,
        },
        {
            name: 'qlive_partner',
            items: menuItems.partner,
        },
        {
            name: 'qlive_cronjob',
            items: menuItems.cronjob,
        },
        {
            name: 'qlive_core_admin',
            items: menuItems.admin,
        },
        {
            name: 'qlive_chat',
            items: menuItems.chat,
        },
        {
            name: 'qlive_property_management',
            items: menuItems.property,
        },
        {
            name: 'qlive_thriftshop',
            items: menuItems.thriftshop,
        },
    ],
    thirdPartyApiKeys: {
        googleMapsEmbedApi: process.env.GOOGLE_MAPS_API_KEY ?? '',
    },
    cmsConnectLoad: 'partner',
};

export default config;
export const drawerWidth = 260;
